import React, { Component } from 'react';
import {
  NavbarToggler,
} from 'reactstrap';
import Searchbar from '../searchbar.js'
import './index.css'
import { Link, withRouter } from 'react-router-dom';
// import AdSense from 'react-adsense';
import Cookies from 'js-cookie';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: Cookies.get('token') || Cookies.get('accessToken') ? true : false
    }
  }
  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  render() {
    return (
      <header className="app-header navbar justify-content-start">
        <NavbarToggler className="d-md-none" onClick={this.mobileSidebarToggle}>
          <span className="navbar-brand"></span>
        </NavbarToggler>
        <Link to={this.state.isLoggedIn ? '/search' : '/'} className="navbar-brand navbar-brand-hidden navbar-brand" />
        <div className='col' style={{ display: "flex", alignItems: "center" }}>
          <Searchbar className="mr-auto col" />
          { <Link to={'javascript:void(0)'}  onClick={this.mobileSidebarToggle} style={{display: "none"}} className="sidebar-toggle" ><i className="fa fa-bars"></i></Link>}
        { <Link to={'/add-your-company'} style={{textDecoration: "underline "}} className={"font-weight-bold add-company-btn"} >Add Company</Link>}
          
          <div className='ml-auto header-btn-group  col'>
            {!this.state.isLoggedIn &&
              <React.Fragment>
                <Link to='/login' className="login-header"><i className='icon-login'></i> Sign In</Link>
                <Link to='/join' className="join-header"><i className="fa  fa-users"></i> Join Now</Link>
              </React.Fragment>}
            {this.state.isLoggedIn &&
              <a className='login-header' href="/logout"><i className='icon-logout'></i> Logout</a>
            }
          </div>
        </div>
      </header>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./client/src/components/Header/Header.js